//import EnvironmentManager from 'Utils/environmentManager';

const isAlphanumericChecker = () => {
  /*
    TO DO: CMS alphanumeric kontrol edilecek şimdilik true set edildi.
    const cmsKey = EnvironmentManager.getMessageText({ key: 'alphanumeric' });
  */
  const cmsKey = 'true';

  if (cmsKey === 'true') {
    return {
      regexControl: false,
      maxLength: 8
    };
  } else {
    return {
      regexControl: true,
      maxLength: 6
    };
  }
};

export const isAlphanumeric = isAlphanumericChecker();